import { FC } from 'react';
import { css } from '@emotion/react';
import { spacing, colors } from '../../../styles';

interface ParsedToolOutput {
  type?: string;
  status?: string;
  message?: string;
  [key: string]: any;
}

interface ToolRendererProps {
  toolName: string;
  output: ParsedToolOutput;
  isLoading?: boolean;
}

export const StatsRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        Loading statistics...
      </div>
    );
  }

  const stats = output.stats || output.data || output;
  if (typeof stats === 'object' && stats !== null) {
    const keyStats = Object.entries(stats).slice(0, 4);
    return (
      <div
        css={css`
          margin: ${spacing.centi} 0 0 0;
        `}
      >
        {keyStats.map(([key, value]: [string, any], index: number) => (
          <div
            key={index}
            css={css`
              display: flex;
              justify-content: space-between;
              margin-bottom: ${spacing.centi};
              font-size: 14px;
              line-height: 1.4;
            `}
          >
            <span
              css={css`
                color: ${colors.silver};
              `}
            >
              {key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
            </span>
            <span
              css={css`
                color: ${colors.liquorice};

                html[data-theme='dark'] & {
                  color: ${colors.sugar};
                }
              `}
            >
              {typeof value === 'number' ? value.toFixed(2) : value}
            </span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      css={css`
        font-size: 14px;
        color: ${colors.silver};
      `}
    >
      Statistics retrieved
    </div>
  );
};
